
export const fakeApiWeek = [
  {
    day: '??',
    img: '',
    tempMax: '??',
    tempMin: '??',
    id: 1
  },
  {
    day: '??',
    img: '',
    tempMax: '??',
    tempMin: '??',
    id: 2
  },
  {
    day: '??',
    img: '',
    tempMax: '??',
    tempMin: '??',
    id: 3
  },
  {
    day: '??',
    img: '',
    tempMax: '??',
    tempMin: '??',
    id: 4
  },
  {
    day: '??',
    img: '',
    tempMax: '??',
    tempMin: '??',
    id: 5
  },
  {
    day: '??',
    img: '',
    tempMax: '??',
    tempMin: '??',
    id: 6
  },
]
export const fakeApiHours = [
  {
    day: '??',
    img: '',
    temp: '??',
    id: 1
  },
  {
    day: '??',
    img: '',
    temp: '??',
    id: 2
  },
  {
    day: '??',
    img: '',
    temp: '??',
    id: 3
  },
  {
    day: '??',
    img: '',
    temp: '??',
    id: 4
  },
  {
    day: '??',
    img: '',
    temp: '??',
    id: 5
  },
  {
    day: '??',
    img: '',
    temp: '??',
    id: 6
  },

]